import { useTranslation } from 'react-i18next';

export function useCustomerSettings(): {
  label: string;
  href?: string;
  onClick?: () => void;
}[] {
  const { t } = useTranslation('common');

  return [
    {
      label: t('userMenu.settings'),
      href: '/bp/c/settings',
    },
    {
      label: t('userMenu.orders'),
      href: '/bp/c/orders',
    },
    {
      label: t('userMenu.logout'),
      href: '/auth/logout',
    },
  ];
}
